import awsExports from 'aws-exports';

/**
 * Base URL for the AdminAgent Lambda Function URL (no trailing slash, no path).
 * Deployed to agentdev; override per machine with `VITE_ADMIN_AGENT_URL`.
 */
const AGENTDEV_ADMIN_AGENT_FUNCTION_URL =
  'https://pclfgsac4awo2pn4j3hd7gktfa0ldikp.lambda-url.us-east-1.on.aws';

function isAgentdevAmplifyBackend(): boolean {
  const bucket = awsExports.aws_user_files_s3_bucket as string | undefined;
  return typeof bucket === 'string' && bucket.includes('-agentdev');
}

/**
 * Resolves where `AdminAgentDrawer` should POST `/chat`.
 * 1. `VITE_ADMIN_AGENT_URL` when set (any backend).
 * 2. Hard-coded agentdev Function URL when pulled `aws-exports` is for agentdev.
 * 3. Otherwise `undefined` → local demo mode (no network).
 */
export function resolveAdminAgentBaseUrl(): string | undefined {
  const fromEnv = import.meta.env.VITE_ADMIN_AGENT_URL?.trim().replace(/\/$/, '');
  if (fromEnv) return fromEnv;

  if (isAgentdevAmplifyBackend()) {
    return AGENTDEV_ADMIN_AGENT_FUNCTION_URL.replace(/\/$/, '');
  }

  return undefined;
}
